import PropTypes from "prop-types"
import React, { Component } from "react"

//Simple bar
import SimpleBar from "simplebar-react"

// MetisMenu
import MetisMenu from "metismenujs"
import { withRouter } from "react-router-dom"
import { Link } from "react-router-dom"

//i18n
import { withTranslation } from "react-i18next"

class SidebarContent extends Component {
  constructor(props) {
    super(props)
    this.refDiv = React.createRef()
  }

  componentDidMount() {
    this.initMenu()
  }

  // eslint-disable-next-line no-unused-vars
  componentDidUpdate(prevProps, prevState, ss) {
    if (this.props.type !== prevProps.type) {
      this.initMenu()
    }
  }

  initMenu() {
    new MetisMenu("#side-menu")

    let matchingMenuItem = null
    const ul = document.getElementById("side-menu")
    const items = ul.getElementsByTagName("a")
    for (let i = 0; i < items.length; ++i) {
      if (this.props.location.pathname === items[i].pathname) {
        matchingMenuItem = items[i]
        break
      }
    }

    if (matchingMenuItem) {
      this.activateParentDropdown(matchingMenuItem)
    }
  }

  // componentDidUpdate() {}

  scrollElement = item => {
    setTimeout(() => {
      if (this.refDiv.current !== null) {
        if (item) {
          const currentPosition = item.offsetTop
          if (currentPosition > window.innerHeight) {
            if (this.refDiv.current)
              this.refDiv.current.getScrollElement().scrollTop =
                currentPosition - 300
          }
        }
      }
    }, 300)
  }

  activateParentDropdown = item => {
    item.classList.add("active")
    const parent = item.parentElement

    const parent2El = parent.childNodes[1]
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show")
    }

    if (parent) {
      parent.classList.add("mm-active")
      const parent2 = parent.parentElement

      if (parent2) {
        parent2.classList.add("mm-show") // ul tag

        const parent3 = parent2.parentElement // li tag

        if (parent3) {
          parent3.classList.add("mm-active") // li
          parent3.childNodes[0].classList.add("mm-active") //a
          const parent4 = parent3.parentElement // ul
          if (parent4) {
            parent4.classList.add("mm-show") // ul
            const parent5 = parent4.parentElement
            if (parent5) {
              parent5.classList.add("mm-show") // li
              parent5.childNodes[0].classList.add("mm-active") // a tag
            }
          }
        }
      }
      this.scrollElement(item)
      return false
    }
    this.scrollElement(item)
    return false
  }

  render() {
    return (
      <React.Fragment>
        <SimpleBar style={{ maxHeight: "100%" }} ref={this.refDiv}>
          <div id="sidebar-menu">
            <ul className="metismenu list-unstyled" id="side-menu">
              <li className="menu-title">{this.props.t("Menu")}</li>
              <li>
                <Link to="/dashboard" className="waves-effect">
                  <i className="bx bx-home-circle" />

                  <span>{this.props.t("Dashboard")}</span>
                </Link>
              </li>

              {/* Manage Users */}
              <li className="menu-title">{this.props.t("Manage Users")}</li>
              <li>
                <Link to="/#" className="has-arrow waves-effect">
                  <i className="bx bx-credit-card" />
                  <span>{this.props.t("Manage Credit")}</span>
                </Link>
                <ul className="sub-menu" aria-expanded="false">
                  <li>
                    <Link to="/manage-users/buy-call-credit">
                      {this.props.t("Buy Call Credit")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/manage-users/transfer-call-credit">
                      {this.props.t("Transfer Call Credit")}
                    </Link>
                  </li>
                </ul>
              </li>
              <li>
                <Link to="/manage-users/call-log" className=" waves-effect">
                  <i className="bx bx-history" />
                  <span>{this.props.t("Manage Call Log")}</span>
                </Link>
              </li>
              <li>
                <Link to="/#" className="has-arrow waves-effect">
                  <i className="bx bx-map-pin" />
                  <span>{this.props.t("Manage Numbers")}</span>
                </Link>
                <ul className="sub-menu" aria-expanded="false">
                  <li>
                    <Link to="/manage-users/local-numbers">
                      {this.props.t("Manage Local Numbers (Magico Numbers)")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/manage-users/caller-ids">
                      {this.props.t("Caller IDs (Pinless Numbers)")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/manage-users/follow-me-numbers">
                      {this.props.t("Follow Me Number")}
                    </Link>
                  </li>
                </ul>
              </li>
              {/* <li>
                <Link to="/manage-users/customer" className="waves-effect">
                  <i className="bx bx-gift" />
                  <span>{this.props.t("Manage Customers")}</span>
                </Link>
              </li> */}
              <li>
                <Link to="/manage-users/customers" className="waves-effect">
                  <i className="bx bx-group" />
                  <span>{this.props.t("Customers")}</span>
                </Link>
              </li>

              <li>
                <Link
                  to="/manage-users/authorized-countries"
                  className="waves-effect"
                >
                  <i className="bx bx-globe" />
                  <span>{this.props.t("Authorized Countries")}</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/manage-users/voucher-recharge"
                  className="waves-effect"
                >
                  <i className="bx bx-gift" />
                  <span>{this.props.t("Voucher Recharge")}</span>
                </Link>
              </li>
              {/* Components */}
              <li className="menu-title">{this.props.t("Components")}</li>
              <li>
                <Link to="/components/traffics" className="waves-effect">
                  <i className="bx bxs-traffic" />
                  <span>{this.props.t("Traffics")}</span>
                </Link>
              </li>
              <li>
                <Link to="/components/sales" className="waves-effect">
                  <i className="bx bx-purchase-tag-alt" />
                  <span>{this.props.t("Sales")}</span>
                </Link>
              </li>
              {/* <li>
                <Link to="/components/registrations" className="waves-effect">
                  <i className="bx bx-gift" />
                  <span>{this.props.t("Manage Registrations")}</span>
                </Link>
              </li> */}
              <li>
                <Link to="/components/emails" className="waves-effect">
                  <i className="bx bx-envelope" />
                  <span>{this.props.t("Manage Emails")}</span>
                </Link>
              </li>
              <li>
                <Link to="/components/sms" className="waves-effect">
                  <i className="bx bx-message" />
                  <span>{this.props.t("Manage SMS")}</span>
                </Link>
              </li>
              {/* Services */}
              <li className="menu-title">Services</li>
              <li>
                <Link to="/services/rates" className="waves-effect">
                  <i className="bx bx-user-circle" />
                  <span>{this.props.t("Rates")}</span>
                </Link>
              </li>
              <li>
                <Link to="/services/access-numbers" className="waves-effect">
                  <i className="bx bx-phone" />
                  <span>{this.props.t("Access Numbers")}</span>
                </Link>
              </li>
              <li>
                <Link to="/#" className="waves-effect">
                  <span className="badge badge-pill badge-success float-right">
                    {this.props.t("New")}
                  </span>
                  <i className="bx bxs-news" />

                  <span>{this.props.t("Blog")}</span>
                </Link>
                <ul className="sub-menu" aria-expanded="false">
                  <li>
                    <Link to="/services/blog-list">
                      {this.props.t("Blog List")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/services/blog-grid">
                      {this.props.t("Blog Grid")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/services/blog-details">
                      {this.props.t("Blog Details")}
                    </Link>
                  </li>
                </ul>
              </li>
              <li>
                <Link to="/services/partner-list" className="waves-effect">
                  <i className="bx bx-file" />
                  <span>{this.props.t("Partners")}</span>
                </Link>
              </li>
              <li>
                <Link to="/services/social" className="waves-effect">
                  <i className="bx bx-share-alt" />
                  <span>{this.props.t("Social Media Accounts")}</span>
                </Link>
              </li>
              {/* Settings */}
              <li className="menu-title">
                <i className="bx bx-cog" />
                {this.props.t("Settings")}
              </li>
              <li>
                <Link to="/settings/user-settings" className="waves-effect">
                  <i className="bx bx-cog" />
                  <span>{this.props.t("User Settings")}</span>
                </Link>
              </li>
              <li>
                <Link to="/settings/user-profile" className="waves-effect">
                  <i className="bx bx-user" />
                  <span>{this.props.t("User Profile")}</span>
                </Link>
              </li>
              <li>
                <Link to="/settings/manage-roles" className="waves-effect">
                  <i className="bx bx-selection" />
                  <span>{this.props.t("Manage Roles")}</span>
                </Link>
              </li>
            </ul>
          </div>
        </SimpleBar>
      </React.Fragment>
    )
  }
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
  type: PropTypes.string,
}

export default withRouter(withTranslation()(SidebarContent))
